export class ConsumerCenter {
  id: number | null;
  code: string;
  name: string;

  constructor() {
    this.id = null;
    this.code = '';
    this.name = '';
  }
}
